module.exports = __webpack_public_path__ + "media/bootstrap-icons/telephone-dd5546b9.svg";